var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"platform-maintenance"},[_c('HelperViewStatus',{attrs:{"title":_vm.helperViewData.title,"description":_vm.helperViewData.description,"status":_vm.helperViewData.status,"button-label":"Tentar novamente"},on:{"click":_vm.redirectToOverview}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }